import { Observable } from 'rxjs';

export function getObfClientLoadedSubscription(): Observable<void> {
    return new Observable((subscriber) => {
        const timeOut = setTimeout(() => {
            clearInterval(interval);

            // disable temporary to prevent spam
            // subscriber.error(new Error('Check if page load obf'));
            subscriber.complete();
        }, 25000);

        const interval = setInterval(() => {
            if ((window as any).obfClientSDK) {
                clearInterval(interval);
                clearTimeout(timeOut);
                subscriber.next();
                subscriber.complete();
            }
        }, 250);
    });
}
